import {translate} from "@/services/translation/translation";

declare let categoryData;

export const getCategoryData = () => {
    if (typeof categoryData != "undefined")
        return categoryData;
    return [];
};

declare let lifechallenge_category_url_1;

export const getLifechallengeCategoryUrl1 = () => {
    if (typeof lifechallenge_category_url_1 != "undefined")
        return lifechallenge_category_url_1;
    return '';
};

declare let lifechallenge_category_url_2;

export const getLifechallengeCategoryUrl2 = () => {
    if (typeof lifechallenge_category_url_2 != "undefined")
        return lifechallenge_category_url_2;
    return '';
};

declare let lifechallenge_category_url_3;

export const getLifechallengeCategoryUrl3 = () => {
    if (typeof lifechallenge_category_url_3 != "undefined")
        return lifechallenge_category_url_3;
    return '';
};

declare let lifechallenge_category_url_4;

export const getLifechallengeCategoryUrl4 = () => {
    if (typeof lifechallenge_category_url_4 != "undefined")
        return lifechallenge_category_url_4;
    return '';
};

declare let lifechallenge_category_url_5;

export const getLifechallengeCategoryUrl5 = () => {
    if (typeof lifechallenge_category_url_5 != "undefined")
        return lifechallenge_category_url_5;
    return '';
};

declare let lifechallenge_category_url_6;

export const getLifechallengeCategoryUrl6 = () => {
    if (typeof lifechallenge_category_url_6 != "undefined")
        return lifechallenge_category_url_6;
    return '';
};

declare let lifechallenge_category_base_url;

export const getLifechallengeCategoryBaseUrl = () => {
    if (typeof lifechallenge_category_base_url != "undefined")
        return lifechallenge_category_base_url;
    return '';
};


declare let countryTranslations;
declare let availableCountries;

export const getCountryTranslations = () => {
    if (typeof countryTranslations != "undefined" && typeof availableCountries != "undefined"){


        let newCountryTrans :any = new Array();

        let country = {};
        country['id'] = "";
        country['name'] = translate("all_countries");

        $.each(availableCountries, (cindex, countryCategoryArray)=>{
            let countrySubArray :any = new Array();
            $.each(countryCategoryArray, (ci, country)=>{
                $.each(countryTranslations, function (index :string,value) {
                    if("countries_"+country == index){
                        let country = {};
                        country['id'] = index.replace("countries_", "");
                        country['name'] = value;
                        countrySubArray.push(country);
                    }
                })
            });
            countrySubArray = countrySubArray.sort((a, b) => (a.name > b.name) ? 1 : -1);
            countrySubArray.unshift(country);
            newCountryTrans.push(countrySubArray);
        });
        return newCountryTrans;
    }else{
        return [{id: '', name:''}];
    }
}

declare let isJury;
export const getIsJury = () => {
    if (typeof isJury != "undefined")
        return isJury;
    return '';
};
